import { c as _c } from "react/compiler-runtime";
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { RouteErrorBoundary } from '@/idv2/components/errors/route-error-boundary';
import { AppShell } from '@/idv2/features/app-shell';
import { useThrowIfSuperseded } from '@/idv2/hooks/use-throw-if-superseded';
import type { RouterContext } from './router-context';
export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RouteErrorBoundary,
  context: () => ({}) as RouterContext
});
function RootComponent() {
  const $ = _c(1);
  useThrowIfSuperseded();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AppShell><Outlet /></AppShell>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}